import React from "react";
import { Phone, MapPin } from "lucide-react";
import { FadeUp, GemMark } from "./Reveal";

export default function Contact() {
    return (
        <section id="contact" data-testid="contact-section" className="py-24 sm:py-32 bg-obsidian-soft border-t border-gold/10 relative overflow-hidden">
            <div className="absolute -top-40 right-0 w-[600px] h-[600px] rounded-full bg-gold/5 blur-3xl pointer-events-none" />
            <div className="max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-12 gap-12 items-center relative z-10">
                <div className="md:col-span-7">
                    <FadeUp>
                        <p className="eyebrow">Contact</p>
                        <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl mt-4 leading-tight">
                            A warm welcome, <span className="italic text-gold-gradient">one call away.</span>
                        </h2>
                        <a
                            href="tel:7209661797"
                            data-testid="contact-call-button"
                            className="relative inline-flex items-center gap-4 mt-10 bg-gold text-obsidian font-semibold px-8 py-5 text-base sm:text-lg tracking-wide hover:bg-gold-light hover:shadow-[0_0_50px_rgba(212,175,55,0.4)] transition-all duration-300"
                        >
                            <span className="ripple-dot" />
                            <Phone size={20} strokeWidth={2.4} />
                            7209661797
                        </a>
                        <p className="text-muted text-sm mt-5">Drop by any time, or call ahead — we're always happy to help.</p>
                    </FadeUp>
                </div>

                <div className="md:col-span-5">
                    <FadeUp delay={0.15}>
                        <div data-testid="address-card" className="card-frame p-8 sm:p-10">
                            <GemMark size={34} />
                            <h3 className="font-display text-2xl text-gold-light mt-5">Visit our store</h3>
                            <div className="flex gap-3 mt-5 text-clay text-sm leading-relaxed">
                                <MapPin size={17} className="text-gold shrink-0 mt-0.5" />
                                <p>
                                    Maa Gayatri Jewellers,
                                    <br />
                                    Jadia, Thana Road,
                                    <br />
                                    Supaul District, Bihar
                                </p>
                            </div>
                            <div className="hairline my-6" />
                            <p className="text-muted text-sm leading-relaxed">
                                A wedding, a festival or any special moment — new jewellery or exchange of old,
                                just call us directly: <span className="text-gold-light font-semibold">7209661797</span>
                            </p>
                        </div>
                    </FadeUp>
                </div>
            </div>
        </section>
    );
}
